export const isDeliveredStatus = (status) =>
  String(status || '').toLowerCase() === 'delivered'

const REVERT_ALLOWED_ROLES = ['System Admin', 'Admin', 'Accountant', 'Hub Admin']

export const revertDeliveryDisabledReason = (shipment, user) => {
  if (!isDeliveredStatus(shipment?.status)) return 'Not delivered'
  if (shipment?.can_revert_delivery === false) {
    return shipment.delivery_revert_blocked_reason || 'Revert is not available'
  }
  const role = user?.role
  if (!REVERT_ALLOWED_ROLES.includes(role)) {
    return 'Only Admin / Hub Admin / Accountant can revert delivery'
  }
  if (shipment?.can_revert_delivery === true) return ''
  return ''
}

export const canRevertDelivery = (shipment, user) =>
  revertDeliveryDisabledReason(shipment, user) === ''

export const canRevertReceiveToDispatch = (shipment, user) => {
  const role = user?.role || user?.role_name
  if (!['System Admin', 'Admin'].includes(role)) return false
  return String(shipment?.status || '').toLowerCase() === 'received'
}
